
(function ($) {
    $(window).on("load", function () {
        $(".scrollbar-custom-wrap").mCustomScrollbar({
            axis: 'x',
            autoHideScrollbar: true,
            documentTouchScroll: true,
            advanced: {
                autoScrollOnFocus: false,
                releaseDraggableSelectors: ".tabs__item"
                // extraDraggableSelectors: ".tabs__item",
            }
            // autoDraggerLength: false
        });
    });
})(jQuery);

